// Die Preisliste eines Lieferanten aus einer CSV- oder Excel-Datei (docs/suppliers.md, „Preislisten-Import“).
// Namen, Daten und Einheiten setzt die Komponente selbst dahinter: Der Bundle maskiert Parameter.
export default {
  action: "Preisliste importieren",
  title: "Preisliste importieren",
  steps: {
    file: "Datei",
    columns: "Spalten",
    matching: "Zuordnung",
  },
  file: {
    label: "Datei",
    drop: "CSV- oder Excel-Datei hierher ziehen oder auswählen",
    limits: "CSV oder Excel (.xlsx), bis 10 MB und 5000 Zeilen",
    kind: "Die Preisliste enthält",
    no_file: "Bitte wählen Sie zuerst eine Datei aus.",
    invalid_type: "Bitte wählen Sie eine CSV- oder Excel-Datei (.csv, .xlsx).",
    too_large: "Die Datei ist größer als 10 MB.",
    unreadable: "Die Datei lässt sich nicht lesen. Erwartet wird eine CSV- oder Excel-Datei mit höchstens 5000 Zeilen.",
    expired: "Die Datei liegt nicht mehr vor. Bitte laden Sie sie erneut hoch.",
  },
  columns: {
    rows: "1 Zeile | {n} Zeilen",
    sheet: "Tabellenblatt",
    header_row: "Erste Zeile ist Überschrift",
    field: "Feld",
    column: "Spalte in der Datei",
    samples: "Beispiele",
    column_n: "Spalte {letter}",
    none: "Keine Spalte",
    fields: {
      articleNumber: "Artikelnummer",
      name: "Bezeichnung",
      price: "Preis",
      unit: "Einheit",
      currency: "Währung",
    },
    name_or_article: "Bezeichnung oder Artikelnummer nötig",
    currency: "Währung der Preise",
    currency_fallback: "Währung, wo keine steht",
    valid_from: "Neue Preise gelten ab",
    // Die Tage, die der Server annimmt.
  },
  matching: {
    row_failed: "Preise nicht geladen, bitte neu wählen",
    summary: {
      lines: "1 Zeile gelesen | {n} Zeilen gelesen",
      recognized: "{article} über die Artikelnummer, {name} über den Namen erkannt",
      unchanged: "1 Preis unverändert | {n} Preise unverändert",
      // Maschinenzeilen, deren Zeile im Sortiment in einer anderen Einheit abrechnet (unter „Unklar“).
      other_unit: "1 in anderer Einheit | {n} in anderer Einheit",
    },
    groups_label: "Zeilen zeigen",
    groups: {
      matched: "Zugeordnet",
      ambiguous: "Unklar",
      unmatched: "Nicht gefunden",
      invalid: "Ungültig",
    },
    hide_unchanged: "Unveränderte ausblenden",
    filter: "Zeilen filtern",
    columns: {
      line: "In der Datei",
      problem: "Grund",
      price: "Preis",
      change: "Änderung",
    },
    line: "Zeile",
    by_article: "über die Artikelnummer",
    by_name: "über den Namen",
    new_row: "neu im Sortiment",
    new: "neu",
    unchanged: "unverändert",
    skipped: "wird ausgelassen",
    skip: "Auslassen",
    take: "Übernehmen",
    reassign: "Anders zuordnen",
    create: "Neu anlegen",
    suggestions: "Vorschläge",
    materials: "Weitere Materialien",
    machines: "Weitere Maschinen",
    also_lines: "Ausgelassen: dieselbe Stelle wie Zeile {line}",
    // Eine Maschinenzeile, deren Zeile im Sortiment in einer anderen Einheit abrechnet: nicht übernommen, bis anders
    // zugeordnet. Die Einheiten sind Wörter („Woche“, „Tag“).
    unit_mismatch: "Liste je {line}, Zeile je {row}",
    units: { HOUR: "Stunde", DAY: "Tag", WEEK: "Woche", MONTH: "Monat" },
    problems: {
      PRICE: "Kein lesbarer Preis",
      CURRENCY: "Unbekannte Währung",
      EMPTY: "Ohne Bezeichnung und Artikelnummer",
      OTHER: "Nicht lesbar",
    },
    more: "1 weitere Zeile – über den Filter erreichbar | {n} weitere Zeilen – über den Filter erreichbar",
    empty: "Keine Zeilen.",
    planned: "Keine Zeile wird übernommen | 1 Zeile wird übernommen | {n} Zeilen werden übernommen",
    from: "gültig ab",
  },
  // Die Nummer ist die Zeile der Datei, wie sie die Zuordnung zeigt.
  refused_line: "Zeile {line} wurde nicht angenommen.",
  actions: {
    back: "Zurück",
    next: "Weiter",
    apply: "Übernehmen",
  },
  result: {
    title: "Preisliste übernommen",
    updated: "1 Preis aktualisiert | {n} Preise aktualisiert",
    rows_added: "1 neu im Sortiment | {n} neu im Sortiment",
    created: {
      MATERIAL: "1 Material angelegt | {n} Materialien angelegt",
      MACHINE: "1 Maschine angelegt | {n} Maschinen angelegt",
    },
    unchanged: "1 unverändert | {n} unverändert",
    skipped: "1 ausgelassen | {n} ausgelassen",
    nothing: "Nichts geändert.",
  },
}
